import Header from './../../../Headers/HeaderForAreLoggedIn/index.vue'
import Footer from './../../../Footers/Footer/index.vue'
import ProgressHUD from './../../../ProgressHUD/index.vue'
import QuestionsAnswers from './../../Widget/QuestionsAnswers/index.vue'
import ReputationData from './../../Widget/ReputationData/index.vue'
import { Api, Toast } from './../../../../services'
import { ProductUpdateMixin } from './../../../mixins/ProductUpdate.mixin.js'
import { VueEditor } from 'vue2-editor'
let vm = require('vue')

export default {
  name: 'ProductDuplicate',
  mixins:[ProductUpdateMixin],
  components: {
    Header,
    Footer,
    ProgressHUD,
    QuestionsAnswers,
    ReputationData,
    VueEditor,
  },
  mounted() {
    var _s = this
    this.$refs.selectCountry.onchange = function(){
      _s.product.country = this.value;
    }
    this.$refs.selectPayment.onchange = function(el){
      var selectedPay = [];
      for (let i = 0; i < 5; i++)
        if (this[i].selected === true && !i==0)
          selectedPay.push(this[i].value);

      _s.product.payMethods = selectedPay;
    }
  },
  data() {
    return {
      product: {
        name: '',
        description: '',
        price: '',
        type: '',
        details: {
          dimensions: '',
          number: '',
          weight: '',
          shipping: '',
          manufacture: '',
          asin: '',
        },
        specs: '',
        available: 0,
        images: [''],
        country: '',
        region: '',
        percentGreen: 0,
        payMethods: ''
      },
      payMethods: [{"name": "payment BTC", "value": "btc" }, {"name": "payment ETH", "value": "eth"}, {"name": "Credit Card", "value":"cc"}, {"name": "PayPal", "value": "pp"}],
    }
  },
  methods: {
    async saveProduct() {
      try {
        let isValid = await this.$validator.validateAll('firstForm')
        if (!isValid) return

        this.$refs.progress.show()

        if (!this.editorIsNotEmpty(this.product.description)) return

        if (!this.editorIsNotEmpty(this.product.specs)) return

        var formData = new FormData()
        for (var key in this.product) {
          if (String(key) == 'details' || String(key) == 'images') break

          formData.append(key, this.product[key])
        }

        // Append images to formData
        for (
          var index = 0;
          !(!(index < this.product.images.length) || !(index < 5)); // Upload 5 images or less
          index++
        ) {
          formData.append('files' + index, this.product.images[index])
        }

        formData.append('details', String(JSON.stringify(this.product.details)))
        formData.append('specs', this.product.specs)
        formData.append('name', this.product.name)
        formData.append('description', this.product.description)
        formData.append('available', this.product.available)
        formData.append('price', this.product.price)
        formData.append('images', this.product.images)
        formData.append('country', this.product.country)
        formData.append('percentGreen', this.product.percentGreen)
        formData.append('region', this.product.region)
        formData.append('payMethods', this.product.payMethods)

        var response = await Api.createProduct(formData)

        this.$router.push('/dashboard/')
      } catch (error) {
        console.error(error)
        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: error.message,
        })
      } finally {
        this.$refs.progress.hide()
      }
    },
  },
  async created() {
    this.countries = require('./../../../../data/country.js')
    var response = await Api.getProductById(this.$route.params.id)

    if (response.data && !response.data.error) {
      this.product.name = response.data.results.product.name
      this.product.description = response.data.results.product.description
      this.product.specs = response.data.results.product.specs
      this.product.price = response.data.results.product.price
      this.product.type = response.data.results.product.type
      this.product.details = response.data.results.product.details
      //this.product.images = response.data.results.product.images
      this.product.available = response.data.results.product.available
      this.product.country = response.data.results.product.country
      this.product.region = response.data.results.product.region
      this.product.percentGreen = response.data.results.product.percentGreen
      this.product.payMethods = response.data.results.product.payMethods
      this.newImages = [].concat(this.product.images)
    } else {
      this.validationMessage = 'Something went wrong.'
      console.error('Something went wrong.')
    }

    this.$nextTick(function() {
      $('select').material_select()
      Materialize.updateTextFields()
    })

    this.$refs.progress.hide()
  },
}



// WEBPACK FOOTER //
// ./src/components/Marketplace/Product/Duplicate/ProductDuplicate.component.js